import { render } from "./ProjectSourcesNavBar.vue?vue&type=template&id=b895644a&lang=true"
import script from "./ProjectSourcesNavBar.vue?vue&type=script&lang=js"
export * from "./ProjectSourcesNavBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__